import get from 'lodash/get';
export function siteConfigParser(config, key) {
    var requiredValue = get(config, key) || null;
    return requiredValue;
}
